<div class="dropup zbd-info zas-header-icon">
    <div class="dropdown-toggle">
        <span
            class="zbd-action-icon icon-mobile-nav-menu tracking-action"
            (click)="toggle()"
        ></span>
    </div>
    <ul
        class="dropdown-menu dropdown-menu-ie-fix header-menu main-menu-dropdown"
        #dropdown
    >
        <li *ngIf="hasHome">
            <a [routerLink]="['/']">
                <span class="zas-home-icon prefix-icon"></span> Startseite
            </a>
        </li>
        <ng-content></ng-content>
        <li>
            <a (click)="logout()">
                <span class="icon-share prefix-icon"></span> Abmelden
            </a>
        </li>
    </ul>
</div>
